import { EmissionFactorSource, EmissionFactorType } from "@green0meter/api-client";
import { array, mixed, number, object, string } from "yup";

export const emissionFactorTypeOptions = [
  { value: EmissionFactorType.Basic, labelKey: "optionTypeBasic" },
  { value: EmissionFactorType.Other, labelKey: "optionTypeOther" },
];

export const sourceOptions = [
  {
    value: EmissionFactorSource.Defra,
    labelKey: "source.defra",
  },
  {
    value: EmissionFactorSource.Ecoinvent,
    labelKey: "source.ecoinvent",
  },
  {
    value: EmissionFactorSource.Other,
    labelKey: "source.other",
  },
];

export const schema = object({
  factor: number().required("emissionFactorEditor.validation.factor.required"),
  scope: number().required("emissionFactorEditor.validation.scope.required"),
  type: number().required("emissionFactorEditor.validation.type.required"),
  unitId: string().required("emissionFactorEditor.validation.unit.required"),
  source: mixed<EmissionFactorSource>()
    .oneOf([
      EmissionFactorSource.Defra,
      EmissionFactorSource.Ecoinvent,
      EmissionFactorSource.Other,
    ])
    .required("emissionFactorEditor.validation.source.required"),
  sourceDetail: string().optional(),
  year: number().required("emissionFactorEditor.validation.year.required"),
  pairs: array()
    .of(
      object().shape({
        id: string().required(),
        questionCode: string().required(
          "emissionFactorEditor.validation.questionCode.required",
        ),
      }),
    )
    .required(),
});
